<div class="c-tabs" [ngClass]="{'u-no-mb': vm.isSmall}" *ngIf="vm.tabs?.length">
	<button id="listTab{{$index}}" type="button" (click)="vm.notifyTabChange($index)" class="c-tabs__link" [ngClass]="{'c-tabs__link--active': vm.activeTab === $index, 'c-tabs__link--sm': vm.isSmall}" *ngFor="let tab of vm.tabs; let $index=index">{{ tab.label }}</button>
</div>
